import React from 'react';
import { connect } from 'react-redux';
import toastr from "toastr";
import math from "mathjs";

import Sensor from './sensor';
import Area from './area';
import ListDropdown from "components/common/dropdowncomponents/listdropdown";
import HeatmapExport from 'components/common/dropdowncomponents/dataexportdropdown/heatmapexport';

import { updateSensor, fetchImage } from 'actions/floorplan';
import { getSensorAverage, getParams } from 'actions/stats';

export class FloorPlan extends React.Component {
    constructor(props, context) {
        super(props, context);
        this.state = {
            loading: false,
            isFetched: false,
            isNodeVisible: false,
            heatmapFilter: "ALL", // Show all
            hasPermission: this.hasPermission(),
            url: ""
        };
    }
    getImage(urlList, node) {
        while (node) {
            if (node.info.useownfp) {
                return urlList[node.id.toString()];
            }
            node = node.parent;
        }
        // return undefined
    }

    componentWillReceiveProps(nextProps) {
        this.setState({ hasPermission: this.hasPermission(nextProps) })
        if (this.state.loading) {
            var url = this.getImage(nextProps.images, nextProps.root)
            if (url != this.state.url) {
                this.setState({ url: url, loading: false });
            }
        } else {
            // Check if fetching sensors' average is needed
            var fetchNeeded = false;
            fetchNeeded = fetchNeeded || (!this.props.root && nextProps.root); // first time receive props.root
            fetchNeeded = fetchNeeded || this.querySettingsChanged(this.props.query, nextProps.query);
            fetchNeeded = fetchNeeded || (this.props.root.id != nextProps.root.id);
            fetchNeeded = fetchNeeded || !this.state.isFetched// fetch once for direct link to heatmap
            fetchNeeded && this.fetchSensorAvg(nextProps)
        }
    }
    fetchSensorAvg(props) {
        var params = getParams({
            querySettings: props.query,
            currentNode: props.root
        })
        this.props.dispatch(getSensorAverage(params, props.root))
        this.setState({
            isFetched: !this.state.isFetched
        })
    }
    querySettingsChanged(q1, q2) {
        return (
            q1.startdate !== q2.startdate ||
            q1.enddate !== q2.enddate ||
            q1.starthour !== q2.starthour ||
            q1.endhour !== q2.endhour ||
            q1.weekdaymask !== q2.weekdaymask
        );
    }
    imageError() {
        this.setState({
            loading: true
        })
        this.props.dispatch(fetchImage(this.props.user.companyid))
    }
    onClickHeatNode(e, id) {
        if (this.state.isNodeVisible) {
            var ss = this.props.sensorMap.get(id);
            var currentHidden = ss.hidden;
            var hidden;

            if (currentHidden === true) {
                // console.log("Not visible!");
                hidden = false;
            } else if (currentHidden === false) {
                // console.log("Visible!");
                hidden = true;
            } else {
                console.log("UNSET !!!");
                hidden = true;
            }

            var sensor = {
                id: id,
                hidden: hidden
            }
            this.props.dispatch(updateSensor(sensor)).then((response) => {
                if (response.status == 200) {
                    toastr.success(`Update heat node successfully.`);
                } else {
                    toastr.error(response.data)
                }
            }).catch(error => {
                toastr.error(error.data);
            });
        }
    }
    toggleHide() {
        this.setState({
            isNodeVisible: !this.state.isNodeVisible
        });
    }
    calculateNormalizer() {
        // return mean and std
        var values = [];
        Object.keys(this.props.sensorAverage.values).map((mac) => {
            var value = this.props.sensorAverage.values[mac];
            if (this.props.MACMap[mac] && this.props.MACMap[mac].info.details && !this.props.MACMap[mac].info.details.hidden) {
                if (0 <= value && value <= 1) {
                    values.push(value);
                }
            }
        });
        if (values.length == 0) {
            return [0.5, 1, 1];
        }

        // Lowest 5% value
        var count = Math.round(values.length * 5 / 100);
        var sorted = math.sort(values);

        return [math.mean(values), math.std(values), sorted[count]];
    }
    chooseHeatmapFilter(f) {
        this.setState({
            heatmapFilter: f
        });
    }
    getHeatmapFilterText(f) {
        var text;
        switch (f) {
            case "ALL":
                text = "Show all";
                break;

            case "ABOVE":
                text = "Above average";
                break;

            case "BELOW":
                text = "Below average";
                break;

            case "LOWEST":
                text = "Lowest 5%";
                break;

            default:
                text = "";
        }

        return text;
    }
    render() {
        if (!this.props.root) {
            return null;
        }
        var areas = [], sensors = [];
        this.listNodes(this.props.root, areas, sensors)

        var normalizer = this.calculateNormalizer();


        if (!this.state.loading && !this.props.root.info.empty) {
            var url = this.getImage(this.props.images, this.props.root)
            if (url && this.props.root.info.hasfloorplan) {
                return (
                    <div className={"floorplan-outer-container " + (!this.props.thumbnail ? "not-thumbnail" : "")}>
                        {
                            (!this.props.thumbnail) &&
                            <div className="floorplan-options-container">
                                <div className="floorplan-options">
                                    <div className="options-help">
                                        <React.Fragment>
                                            <div className="help-icon ">
                                                <img className="card-info" src="src/assets/icons/info.svg" alt="info-icon" />
                                            </div>
                                            <div className={!this.state.isNodeVisible ? "help-text ht-show" : "help-text ht-hide"}>Hover over a heat node for more info.</div>
                                            <div className={this.state.isNodeVisible ? "help-text ht-show" : "help-text ht-hide"}>Click on a heat node to hide/unhide it.</div>
                                        </React.Fragment>
                                    </div>
                                    <div className="options-buttons-container">
                                        <div className="options-buttons-wrapper">
                                            <ListDropdown
                                                outsideClass="heatmap-filter"
                                                items={["ALL", "ABOVE", "BELOW", "LOWEST"]}
                                                getText={(f) => this.getHeatmapFilterText(f)}
                                                selected={this.state.heatmapFilter}
                                                click={(f) => this.chooseHeatmapFilter(f)}
                                            />
                                            {(this.state.hasPermission) &&
                                                <div className="options-buttons">
                                                    <i
                                                        className="material-icons"
                                                        data-tooltip={this.state.isNodeVisible ? "Showing hidden heat nodes" : "Not showing hidden heat nodes"}
                                                        onClick={() => this.toggleHide()}
                                                    >
                                                        {this.state.isNodeVisible ? "visibility" : "visibility_off"}
                                                    </i>
                                                </div>
                                            }
                                            <div className="options-buttons">
                                                <HeatmapExport node={this.props.root} heatmap={this.floorplan} />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="floorplan--divider">
                                </div>
                                {this.props.children}
                            </div>
                        }
                        <div ref={(e) => { this.floorplan = e }} className={!this.props.thumbnail ? "floorplan-container" : "floorplan-container-thumbnail"}>
                            <img
                                src={url}
                                alt="Floorplan"
                                className="floorplan-image"
                                ref="floorplan-image"
                                onError={this.imageError.bind(this)}
                                draggable="false"
                                key="image"
                            />
                            {sensors.map((sensor) => {
                                var ss = this.props.sensorMap.get(sensor.id);
                                return (ss &&
                                    <Sensor
                                        key={sensor.id}
                                        normalizer={normalizer}
                                        sensor={ss}
                                        average={this.props.sensorAverage.values[ss.macaddress]}
                                        heatmapFilter={this.state.heatmapFilter}
                                        showHiddenHeatNodes={this.state.isNodeVisible}
                                        thumbnail={this.props.thumbnail}
                                        onClickHeatNode={(e, id) => { this.onClickHeatNode(e, id) }}
                                    />
                                );
                            })}
                            {areas.map((node) => {
                                return (
                                    <Area
                                        key={node.id}
                                        node={node}
                                        thumbnail={this.props.thumbnail}
                                    />
                                );
                            })}
                        </div>
                    </div>
                );
            } else {
                return <div className="floorplan-error">
                    <br />
                    <h2>Oops ! We can't find this location's floorplan...</h2>
                </div>
            }
        } else {
            return <div className="floorplan-error">
                <br />
                <h2>Loading...</h2>
            </div>
        }
    }
    hasPermission(Props) {
        var props = Props || this.props;
        var node = props.root;
        if (props.user.role != "ADMIN" && props.user.role != "SUPPORTUSER") {
            return false;
        }
        while (node) {
            if (node.id == props.user.rootnodeid) {
                return true;
            }
            node = node.parent;
        }
        return false;
    }

    listNodes(root, areas, sensors) {
        var self = this;
        if (root) {
            var isArea = (root.type == "meeting_room" && !this.props.showDetails)
            isArea |= (root.id != this.props.root.id && root.info.useownfp && root.type != "sensor");
            if (isArea) {
                areas.push(root);
            } else {
                if (root.type == "sensor") {
                    sensors.push(root);
                }
                if (root.children) {
                    root.children.forEach((child) => {
                        self.listNodes(child, areas, sensors);
                    });
                }
            }
        }
    }

}

function mapStateToProps(state) {
    return {
        sensorMap: state.nodeReducer.map,
        nodeMap: state.overviewReducer.nodeMap,
        MACMap: state.overviewReducer.MACMap,
        images: state.floorPlanReducer.images,
        user: state.myAccountReducer.user,
        query: state.querySettingsReducer,
        sensorAverage: state.statsReducer.sensorAverage
    }
}
function mapDispatchToProps(dispatch) {
    return {
        dispatch
    };
}
export default connect(mapStateToProps, mapDispatchToProps)(FloorPlan);



// WEBPACK FOOTER //
// ./src/components/pages/heatmap/floorplan.jsx